import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  Condition,
  PriceOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface ReturnValueState {
  amount: string;
  priceOption: PriceOption | null;
}

export const RETURN_VALUE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnValueState>>,
): ConditionType<ReturnValueState, Condition.ReturnValue> => ({
  name: "Individual item price (deprecated)",
  description(state) {
    if (!state.priceOption) {
      return "The price of an individual item the customer is returning";
    }
    return `The price of an individual item is ${state.priceOption.toLowerCase()} ${moneyFormat({ amount: +state.amount, currency: DEFAULT_CURRENCY })}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnValueState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return { amount: model.amount.toFixed(2), priceOption: model.priceOption };
  },
  toModel(state) {
    return {
      type: Condition.RETURN_VALUE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return +state.amount >= 0 && state.priceOption !== null;
  },
});
